import React, { Component } from "react";
import Chart from "chart.js";
import classes from "./Chart_Village_Person_BarChart.module.css";
import { stockData } from "../../assets/data";

var countCranky = 0;
var countJock = 0;
var countLazy = 0;
var countNormal = 0;
var countPeppy = 0;
var countSisterly = 0;
var countSmug = 0;
var countSnooty = 0;
var typeFound = ['Cranky', 'Jock', 'Lazy', 'Normal', 'Peppy', 'Sisterly', 'Smug', 'Snooty' ];
// var myVillPers_array = { 'Cranky': [], 'Jock': [], 'Lazy': [], 'Normal': [], 'Peppy': [], 'Sisterly': [], 'Smug': [], 'Snooty': [] };
var myNumVillPers_array = [];

stockData.map((data, key) => { 
    if (data.personality == 'Cranky') {
        countCranky = countCranky + 1;
    }  
    if (data.personality == 'Jock') {
        countJock = countJock + 1;
    }
    if (data.personality == 'Lazy') {
        countLazy = countLazy + 1;
    }
    if (data.personality == 'Normal') {
        countNormal = countNormal + 1;
    }
    if (data.personality == 'Peppy') {
        countPeppy = countPeppy + 1;
    }
    if (data.personality == 'Sisterly') {
        countSisterly = countSisterly + 1;
    }
    if (data.personality == 'Smug') {
        countSmug = countSmug + 1;
    }
    if (data.personality == 'Snooty') {
        countSnooty = countSnooty + 1;
    } 
});
console.log('Cranky: ' + countCranky);
console.log('Jock: ' + countJock);
console.log('Lazy: ' + countLazy);
console.log('Normal: ' + countNormal);
console.log('Peppy: ' + countPeppy);
console.log('Sisterly: ' + countSisterly);
console.log('Smug: ' + countSmug);
console.log('Snooty: ' + countSnooty);

myNumVillPers_array.push(countCranky);
myNumVillPers_array.push(countJock);
myNumVillPers_array.push(countLazy);
myNumVillPers_array.push(countNormal);
myNumVillPers_array.push(countPeppy);
myNumVillPers_array.push(countSisterly);
myNumVillPers_array.push(countSmug);
myNumVillPers_array.push(countSnooty);

/* myVillPers_array.Cranky = countCranky;
myVillPers_array.Jock   = countJock;
myVillPers_array.Lazy   = countLazy;
myVillPers_array.Normal = countNormal;
myVillPers_array.Sisterly = countSisterly;
myVillPers_array.Smug = countSmug;
myVillPers_array.Snooty = countSnooty; */

export default class Villagers_chartFormat extends Component {
    chartRef = React.createRef();

    componentDidMount() {
        const myChartRef = this.chartRef.current.getContext("2d"); 

        new Chart(myChartRef, {
            type: "bar",
            data: {
                //Bring in data
                labels: typeFound, // typeFound // labels // ['A','B','C']
                datasets: [{
                    label: 'Personality Type',  
                    data: myNumVillPers_array, // numFound // data // [2,6,9]   		
                    backgroundColor: [
                        "rgba(54, 162, 235, 0.5)",
                        "rgba(255, 99, 132, 0.5)",			
                        "rgba(255, 206, 86, 0.5)",
                        "rgba(75, 192, 192, 0.5)",
                        "rgba(153, 102, 255, 0.5)", 
                        "rgba(138, 19, 55, 0.5)", 
                        "rgba(227, 3, 252, 0.5)",
                        "rgba(9, 87, 12, 0.5)"
                    ],
                    borderColor: [
                        "rgba(54, 162, 235, 1)",
                        "rgba(255, 99, 132, 1)",			
                        "rgba(255, 206, 86, 1)",
                        "rgba(75, 192, 192, 1)",
                        "rgba(153, 102, 255, 1)", 
                        "rgba(138, 19, 55, 1)", 
                        "rgba(227, 3, 252, 1)",
                        "rgba(9, 87, 12, 1)"
                    ],
                    borderWidth: 1,
                    fill: true,
                    lineTension: 0.3              
                  }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                  xAxes: [{
                      ticks: { beginAtZero: true }
                  }]  
                    
                }
              }
        });
    
    
    }
    render() {
        return (
            <div className={classes.graphContainer}>
                <canvas
                    id="myChart"
                    ref={this.chartRef}
                />
            </div>

        )
    }   
}    